import { MdOutlineFileUpload } from 'react-icons/md';
import { Link } from 'react-router-dom';
import { FilterIcon } from '../../../../../../assets/svg/filter';
import { PlusIcon } from '../../../../../../assets/svg/plus';
import { SettingsIcon } from '../../../../../../assets/svg/settings';
import { Button } from '../../../../../../components/button/button';
import { DropdownFilter } from '../../../../../../features/dropdown-filter/dropdown-filter';
import { HasAccess } from '../../../../../../features/has-access/has-access';
import { concatPath } from '../../../../../../helpers/path';
import { ManagerPath, RootPath, StaffPath } from '../../../../../../routes/manager/manager-enums';
import { ShiftsControlsScheduleModal } from './shifts-controls-schedule-modal/shifts-controls-schedule-modal';
import { ShiftsControlsSettingsModal } from './shifts-controls-settings-modal/shifts-controls-settings-modal';
import s from './shifts-controls.module.css';
import { useShiftsControls } from './use-shifts-controls';

export const ShiftsControls = () => {
  const { t, scheduleModal, scheduleNotificationsModal, branches, tag, getLocale } =
    useShiftsControls();

  return (
    <div className={s.feature}>
      <h2>{t('Планирование и расписание смен')}</h2>

      <ul className={s.controls}>
        <DropdownFilter
          label={t('Фильтр')}
          leftIcon={<FilterIcon />}
          options={[
            {
              label: t('По филиалам'),
              value: 'branch',
              filter: 'single-select',
              filterOptions: branches?.map((item) => ({
                id: String(item.id),
                value: getLocale(item.name),
              })),
            },
            {
              label: t('По должностям'),
              value: 'tag',
              filter: 'multi-select',
              filterOptions: tag,
            },
          ]}
        />

        <HasAccess service="staff" permissions={['write']}>
          <Link
            to={concatPath([RootPath.Manager, ManagerPath.Staff, StaffPath.ShiftsImport])}
            className="hide__M hide__S"
          >
            <Button data-test="import-schedule" size="lg" fullWidth>
              <MdOutlineFileUpload />
              {t('Импорт')}
            </Button>
          </Link>

          <Button
            data-test="import-schedule"
            size="lg"
            onClick={() => scheduleNotificationsModal.handleOpenModal()}
          >
            <SettingsIcon />
            {t('Настройка')}
          </Button>

          <Button onClick={() => scheduleModal.handleOpenModal()} size="lg">
            <PlusIcon />
            {t('Добавить расписание')}
          </Button>
        </HasAccess>
      </ul>
      <HasAccess service="staff" permissions={['write']}>
        {scheduleModal.isOpen && (
          <ShiftsControlsScheduleModal onClose={() => scheduleModal.handleCloseModal()} />
        )}
        {scheduleNotificationsModal.isOpen && (
          <ShiftsControlsSettingsModal
            onClose={() => scheduleNotificationsModal.handleCloseModal()}
          />
        )}
      </HasAccess>
    </div>
  );
};
